import Index from '../componentes/Index.vue'
import Form from '../componentes/Form.vue'

const meta ={
    Auth:true,
    lista:'/lista-albaranes-venta',
    guardar:'/guardar-albaran-venta',
    // especial:0,
}
// const meta_albaran_especial ={
//     Auth:true,
//     lista:'/lista-albaranes-especiales',
//     guardar:'/guardar-albaran-especial',
//     especial:1,
// }
const routes = [
    ...route('/lista-albaranes-venta', Index, meta),
    ...route('/guardar-albaran-venta', Form, meta),

    //  ...route('/guardar-albaran-especial', FormAlbaran, meta_albaran_especial),
    //  ...route('/lista-albaranes-especiales', ListaAlbaranes, meta_albaran_especial)
]

function route(path, component = Default, meta = {}) {
	return [{
		path,
		component,
		meta
	}]
}

export default routes